import React from 'react';
import { ManyReveal } from '../ManyReveal/ManyReveal';
import { OneReveal } from '../OneReveal/OneReveal';
import { HatcheningStep } from '../xstate-helpers';

export function RevealStep() {
  return (
    <>
      <HatcheningStep steps={['oneRevealMachine']}>
        <OneReveal />
      </HatcheningStep>
      <HatcheningStep steps={['manyRevealMachine']}>
        <ManyReveal />
      </HatcheningStep>
    </>
  );
}
